import { Component, OnInit, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from "src/app/popup/popup.component";
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import Swal from 'sweetalert2';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,FormsModule, Validators,ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BillingAdjustmentStatusEnumDisplay } from 'src/utilities';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MsalService } from '@azure/msal-angular';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { DateRangeErrorStateMatcher } from 'src/app/approval-history/approval-history/approval-history.component';
import { BillingAdjustmentStatusEnum, dateRangeValidator, formatDateforBAT } from 'src/utilities';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { DigitalCopyPdfService } from "src/app/services/digital-copy-pdf/digital-copy-pdf.service";

@Component({
    selector: 'app-bulk-request-approval-history',
    imports: [FormsModule, MatDatepickerModule, MatDateRangeInput, MatSelectModule, MatError, MatNativeDateModule,
        ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, PopupComponent, CommonModule, MatProgressSpinnerModule, NgxSpinnerModule, MatTableModule, SharedModule], templateUrl: './bulk-request-approval-history.component.html',
    styleUrl: './bulk-request-approval-history.component.scss'
})
export class BulkRequestApprovalHistoryComponent implements OnInit {
  

  selectedData: any;
  isGoodWillRequest: boolean = false;
  chooseDialogRef: any;
  detailData: any[] = [];
  isLoader: boolean = true;
  isDetailView = false;
  dateForm: FormGroup;
  matcher = new DateRangeErrorStateMatcher();
  startDateInvalid: boolean = false;
  endDateInvalid: boolean = false;
  statusFilter: string = '';


  // ✅ Used for master table display
  readonly mainTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    { label: 'Total Customers', propertyName: 'customerCount' },
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'Description', propertyName: 'descriptionComment' },
    { label: 'Amount', propertyName: 'adjNetAmount' },
    { label: 'Special Instructions', propertyName: 'specialInstructions' },
    { label: 'Status', propertyName: 'status' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
  { label: 'Requester', propertyName: 'requestor' },
    //{ label: 'MI Remarks', propertyName: 'rejectionReason' },
    
       {
      label: 'Action', propertyName: 'icon',
      icons: [
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'viewDetails' },
      { toolTip: 'Download Files', icon: 'download' , callFrom:'download'},
      {
        toolTip: 'Digital Copy PDF',
        icon: 'picture_as_pdf',
        callFrom: 'digital-copy-pdf'
      }
      ]
    }
  ];

  // ✅ Used for detail table display
  readonly detailTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    // { label: 'Details Id', propertyName: 'detailsId' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'customerName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    { label: 'Check Request', propertyName: 'checkRequest' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    { label: 'Adjustment Method', propertyName: 'adjustmentMethod' },
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'firstLevelApprover' },
    { label: 'MI Remarks', propertyName: 'firstLevelRemarks' },
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'gbsRemarks' },
  ];
 invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
  checked: boolean = true;
  dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);
  isAccepted: boolean = true;
  firstFormGroup: FormGroup;
  panels: any[] = [];
  isLoading: boolean = false;
  allAdjustments: BillingAdjustmentDetails[] = [];


  validateDateRange() {
    const startDate = this.dateForm.get('startDate')?.value;
    const endDate = this.dateForm.get('endDate')?.value;
    this.startDateInvalid = false;
    this.endDateInvalid = false;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start > end) {
        this.startDateInvalid = true;
        this.endDateInvalid = true;
      }
    }
  }

  constructor(private dialog: MatDialog,
    private modalService: BsModalService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private msalService: MsalService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private bulkRequestService: BulkRequestService,
    private digitalCopyPdfService: DigitalCopyPdfService
  ) {
   }

 ngOnInit(): void {
    this.dateForm = this.fb.group({
      startDate: null,
      endDate: null,
      statusFilter: ['0']
    }, { validator: dateRangeValidator });
    this.dateForm.valueChanges.subscribe(() => {
      this.validateDateRange();
    });
   this.getAdjustmentDetails();
  }
  downloadDigitalCopy(adjReqId: string | number) {
    this.digitalCopyPdfService.downloadDigitalCopy(adjReqId);
  }
 getAdjustmentDetails(): void {
  this.spinner.showSpinner();
  const notYetStatuses = [1,2,3,4,5,14,15];
  this.bulkRequestService.getBulkRequestsByClientId(this.msalService.instance.getActiveAccount().username.toString()).subscribe({
    next: response => {
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        data.forEach(x => {
          x.adjRequestDate = formatDate(x.adjRequestDate, 'MM/dd/yyyy', 'en-US');
          x.gbsStatus = x.isGBSNMF
          ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
           notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
        if (
        (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
        (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
      ) {
        x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
      } else {
        x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
        // if(x.statusId==1){
        //   x.status = '--'
        // }else{
        //   x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
        // }             

      }   
        });

        this.dataSource.data = data;
        this.allAdjustments = data;
      } else {
        this.dataSource.data = [];
        this.toastr.warning("No pending adjustments found.", "Notice");
      }

      this.isLoader = false;
      this.spinner.hideSpinner();
    },
    error: err => {
      this.spinner.hideSpinner();
      this.toastr.error("Failed to load adjustment details", "Error");
    }
  });
}
  openAcceptOrRejectDialog(e) {
    this.selectedData = e.details;
  if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
          else if (e.callFrom === 'viewDetails') {
  this.isDetailView = true;
  this.loadDetailsByAdjReqId(e.details.adjReqId);
}
else if (e.callFrom === 'digital-copy-pdf') {
  // Handle digital copy PDF download
  this.downloadDigitalCopy(e.details.adjReqId);
}
  }
  loadDetailsByAdjReqId(adjReqId: number): void {
    this.spinner.showSpinner();
    const notYetStatuses = [1,2,3,4,5,14,15];
    this.bulkRequestService.getBulkUploadDetailsByAdjReqId(adjReqId).subscribe({
      next: (data) => {
        data.forEach(x => {
          x.gbsStatus = x.isGBSNMF
                            ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
                             notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
                          if (
                          (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
                          (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
                        ) {
                          x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
                        } else {
                          x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                          // if(x.statusId==1){
                          //   x.status = '--'
                          // }else{
                          //   x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                          // }             
          
                        }   
        });
        this.detailData = data || [];
        this.invoiceDataSource.data = this.detailData;
      },
      error: (err) => {
        console.error('Failed to load details:', err);
      },
      complete: () => this.spinner.hideSpinner()
    });
  }
  backToDashboard() {
  this.isDetailView = false;
  this.getAdjustmentDetails();
}
onSubmit() {
  this.dateForm.markAllAsTouched();
  if (this.dateForm.invalid) return;

  const startDate = this.dateForm.get('startDate')?.value;
  const endDate = this.dateForm.get('endDate')?.value;
  const statusFilter = this.dateForm.get('statusFilter')?.value;

  const formattedStart = startDate ? new Date(startDate) : null;
  const formattedEnd = endDate ? new Date(endDate) : null;

  // Filter from already-fetched data
  let filtered = this.allAdjustments;

  if (formattedStart && formattedEnd) {
    filtered = filtered.filter(x => {
      const date = new Date(x.adjRequestDate);
      return date >= formattedStart && date <= formattedEnd;
    });
  }

  if (statusFilter && statusFilter !== '0') {
    filtered = filtered.filter(x => x.statusId === +statusFilter);
  }

  // Format statusDesc and adjRequestDate for display
  filtered.forEach(x => {
    x.adjRequestDate = formatDate(new Date(x.adjRequestDate), 'MM/dd/yyyy', "en-US");
    x.statusDesc =
      x.statusId === BillingAdjustmentStatusEnum.Submitted && x.isGBSNMF
        ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation]
        : BillingAdjustmentStatusEnumDisplay[x.statusId];
  });

  this.dataSource.data = filtered;
}

  showTooltip = false;
  tooltipSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
    <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
    <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
    <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
    <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
  </svg>
`;
}


